import { type ComponentProps } from 'react';

import { ChallengeValuationModal } from './ChallengeValuation';
import { CompleteProfileModal } from './CompleteProfile';
import { MoneyWantedModal } from './MoneyWanted';

export type DashboardModalType =
  | 'dashboard.challenge-valuation'
  | 'dashboard.complete-profile'
  | 'dashboard.money-wanted';

export interface DashboardModalPropsMap {
  'dashboard.challenge-valuation': ComponentProps<
    typeof ChallengeValuationModal
  >;
  'dashboard.complete-profile': ComponentProps<typeof CompleteProfileModal>;
  'dashboard.money-wanted': ComponentProps<typeof MoneyWantedModal>;
}

export const dashboardModals = {
  'dashboard.challenge-valuation': ChallengeValuationModal,
  'dashboard.complete-profile': CompleteProfileModal,
  'dashboard.money-wanted': MoneyWantedModal,
};
